import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import FormFieldContainer from '@components/ui/FormFieldContainer';
import InputField, { InputType } from '@components/ui/InputField';
import styles from './ReturnsFields.module.scss';
import Button from '@components/ui/Button';
import Tooltip from '@components/ui/Tooltip';

interface ReturnsFormField {
  value: string;
  set: (value: string) => void;
  isValid: boolean;
}

interface ReturnsFormProps {
  email: ReturnsFormField;
  orderNumber: ReturnsFormField;
  postalCode: ReturnsFormField;
  isDirty: boolean;
}

const ReturnsFields = ({
  email,
  orderNumber,
  postalCode,
  isDirty,
}: ReturnsFormProps) => {
  const { t } = useTranslation('returns');

  return (
    <>
      <FormFieldContainer
        label={t('returns.email.label')}
        htmlFor="returns-form-email"
        errorMessage={
          isDirty && !email.isValid ? t('returns.invalid.email') : undefined
        }
        classNames={styles.fieldContainer}
      >
        <InputField
          id="returns-form-email"
          type={InputType.email}
          value={email.value}
          onChange={email.set}
          hasError={isDirty && !email.isValid}
        />
      </FormFieldContainer>

      <FormFieldContainer
        label={t('returns.orderNumber.label')}
        htmlFor="returns-form-order-number"
        errorMessage={
          isDirty && !orderNumber.isValid
            ? t('returns.invalid.orderNumber')
            : undefined
        }
        classNames={styles.fieldContainer}
      >
        <InputField
          id="returns-form-order-number"
          type={InputType.orderNumber}
          value={orderNumber.value}
          onChange={orderNumber.set}
          hasError={isDirty && !orderNumber.isValid}
          placeholder="SO-"
        />
      </FormFieldContainer>
      <Tooltip
        tooltipContents={
          <span
            dangerouslySetInnerHTML={{
              __html: t('returns.orderLookup.whereToFind.desc'),
            }}
          />
        }
        tooltipId="whereToFind"
      >
        <span className={styles.tooltipText}>
          {t('returns.orderLookup.whereToFind')}
        </span>
      </Tooltip>

      <FormFieldContainer
        label={t('returns.postalCode.label')}
        htmlFor="returns-form-postal-code"
        errorMessage={
          isDirty && !postalCode.isValid
            ? t('returns.invalid.postalCode')
            : undefined
        }
        classNames={styles.fieldContainer}
      >
        <InputField
          id="returns-form-postal-code"
          type={InputType.text}
          value={postalCode.value}
          onChange={postalCode.set}
          hasError={isDirty && !postalCode.isValid}
        />
      </FormFieldContainer>
    </>
  );
};

export default ReturnsFields;
